import React from "react";
import mascotNoData from "../../Assets/icons/okkali_mascot_nodata.png";

const ReportEmptyState = ({
  title = "Veri Bulunamadı",
  message = "Seçilen kriterlere uygun veri bulunamadı.",
  actionButton,
}) => {
  return (
    <div className="bg-gray-50/60 border border-gray-200 rounded-2xl p-8 sm:p-12 text-center select-none">
      <div className="flex flex-col items-center gap-3 sm:gap-5">
        <img
          src={mascotNoData}
          alt="Veri bulunamadı"
          className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 object-contain drop-shadow-lg"
          draggable={false}
        />
        <div>
          <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-700">
            {title}
          </h3>
          <p className="text-sm sm:text-base text-gray-400 mt-1.5 max-w-md mx-auto">
            {message}
          </p>
        </div>
        {actionButton && <div className="mt-3">{actionButton}</div>}
      </div>
    </div>
  );
};

export default ReportEmptyState;
